import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ConfigurationService, IAppSettings } from '../../services/configuration/configuration.service';


@Component({
  selector: 'oir-language-selector',
  templateUrl: './internationalisation.component.html',
  styleUrls: ['./internationalisation.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternationalisationComponent implements OnInit, OnDestroy {
  private toggleSubscription: Subscription;

  @Input() lang: string;

  @Output() readonly change: EventEmitter<string> = new EventEmitter<string>();

  public language: string;

  constructor(private configurationService: ConfigurationService<IAppSettings>,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.configurationService.setCookie('lang', this.translate.currentLang, 30);

    this.setLanguage();
  }

  ngOnDestroy(): void {
    this.unsubscribeToggle();
  }

  toggle(): void {
    const lang = this.translate.currentLang === 'en' ? 'ga' : 'en';
    // Emit value change to parent.
    this.change.emit(lang);

    this.unsubscribeToggle();

    this.toggleSubscription = this.translate
      .use(lang)
      .pipe(tap((lang) => this.translate.reloadLang(lang)))
      .subscribe();

    this.setLanguage();

    this.configurationService.setCookie('lang', lang, 30);
  }

  private unsubscribeToggle(): void {
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
      this.toggleSubscription = null;
    }
  }

  private setLanguage(): void {
    this.language =
      this.translate.currentLang === 'en' ? 'Gaeilge' : 'B\u00E9arla';
  }
}
